import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

// HISNG
import { HisBackendService } from 'hisng';
import { Nomination } from '../model/nomination';

@Injectable()
export class NominationService {

    constructor( private backendService: HisBackendService ) { }

    getNominationById( id: number ): Observable<Nomination> {
        return this.backendService.getData( `api/v1/fs/res/nomination/${id}` );
    }

    /**
     * list of nomination by project id
     *
     * @param id project id
     */
    getNominationsByProject( id: number ): Observable<Nomination[]> {
        return this.backendService.getData( `api/v1/fs/res/nomination/project/${id}` );
    }

    /**
     * list of nominations by by publication id
     *
     * @param id Publication Id
     */
    getNominationsByPublication( id: number ): Observable<Nomination[]> {
        return this.backendService.getData( `api/v1/fs/res/nomination/pub/${id}` );
    }

    /**
     * get nominations by ids from database
     *
     * @param ids a set of nominations ids
     */
    getNominationsByIds( ids: Set<number> ): Observable<Nomination[]> {
        let idsStr = '';
        if ( ids.size > 0 ) {
            for ( let id of ids ) {
                idsStr += id + ',';
            }
            idsStr = idsStr.substring( 0, idsStr.length - 1 );
        }
        return this.backendService.getData( `api/v1/fs/res/nominations/${idsStr}` );
    }

    /**
     * save new or existing nomination data.
     *
     * @param nomination Nomination to save.
     */
    saveNomination( nomination: Nomination ): Observable<Nomination> {
        let savedNomination: Observable<Nomination>;
        if ( nomination.id == null ) {
            savedNomination = this.backendService.postData( 'api/v1/fs/res/nomination', nomination );
        } else {
            savedNomination = this.backendService.putData( `api/v1/fs/res/nomination/${nomination.id}`, nomination );
        }
        return savedNomination;
    }

    /**
     * delete service call to delete nomination from database.
     * returns Observable containing the result of operation.
     *
     * @param nominationId Id of nomination to delete.
     */
    deleteNomination( nominationId: number ): Observable<number> {
        return this.backendService.delete( `api/v1/fs/res/nomination/${nominationId}` );
    }

    canEditNomination( id: number ): Observable<boolean> {
        return this.backendService.postData(
            `api/v1/fs/res/hasRightsOnObject/Nomination/${id}/true`,
            [
                'RIGHT_FS_RES_PRIZE_EDIT_NOMINATION',
                'RIGHT_FS_RES_PRIZE_EDIT_NOMINATION_OWN'
            ] );
    }
}
